import React from 'react';

export default class Scrollable extends React.Component {

    static defaultProps = {
        scrollY: true,
        scrollX: false
    };

    constructor(props) {
        super(props);
        this.state = {
            children: this.props.children,
            scrollY: this.props.scrollY,
            scrollX: this.props.scrollX
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            children: nextProps.children
        });
    }

    render(){
        let scrollClassNames = 'scrollable ';
        if(this.state.scrollY) scrollClassNames += 'scroll-y ';
        if(this.state.scrollX) scrollClassNames += 'scroll-x ';

        return (
            <div className={ scrollClassNames + this.props.className } >
                { this.state.children }
            </div>
        )
    }
};